/* eslint-disable react/jsx-pascal-case */
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import cn from 'classnames';

import { checkPath } from '../../utils/helpers';
import dropdown from '../../elements/DropDown/DropDown.module.scss';
import { setMenuOpen } from '../../redux/mobileMenu/mobileMenuActions';
import Routes from '../Routes';
import HeaderLink from '../HeaderLink/HeaderLink';
import Icons from '../Icons';
import { logout } from '../auth/redux/authActions';
import Switcher from '../Switcher';
import DropDown from '../../elements/DropDown/DropDown';
import { Desktop, Tablet, Mobile } from '../../utils/responsiveQueries';
import { getFlagProperty } from '../../redux/flags/flags';
import { toggleSupportMessage } from '../../redux/reducers/support';
import strings from '../../lang/lang';
import ProdSwitcher from '../ProdSwitcher';
import UnauthorizedLinks from './UnauthorizedLinks';
import useFetchEnv from './useFetchEnv';
import header from './Header.module.scss';
import Burger from './Burger';
import { NavigationMenu } from '..';
import ApiVersions from '../../pages/apis/ApiVersions';
import { ReactComponent as ArrowIcon } from '../../styles/icon/header/arrow.svg';
import { ReactComponent as ArrowPink } from '../../styles/icon/header/arrow-pink.svg';
import { ReactComponent as HeaderApps } from '../../styles/icon/header/apps.svg';
import { ReactComponent as HeaderSupport } from '../../styles/icon/header/support.svg';
import { ReactComponent as HeaderFintoIo } from '../../styles/icon/header/staq-io.svg';
import { keycloak } from '../../keycloak-config';

const mapStateToProps = (state) => {
  return {
    isHeaderHome: getFlagProperty(state, 'isHeaderHome'),
    isHeaderAbout: getFlagProperty(state, 'isHeaderAbout'),
    isHeaderContact: getFlagProperty(state, 'isHeaderContact'),
    isHeaderTermsLegals: getFlagProperty(state, 'isHeaderTermsLegals'),
    isSwitcherOpen: state.switcher.isSwitcherOpen,
    isProdSwitcherOpen: state.prodSwitcher.isProdSwitcherOpen,
    infoApi: state.info.data,
    sdkPages: state.ghost.sdkPages,
  };
};

const mapDispatchToProps = {
  setMenuOpen,
  toggleSupportMessage,
};

const Header = (props) => {
  const {
    isHeaderHome,
    isHeaderAbout,
    isHeaderContact,
    isHeaderTermsLegals,
    enteredClassName,
    isSwitcherOpen,
    isProdSwitcherOpen,
    history,
    setMenuOpen,
    location,
    toggleSupportMessage,
  } = props;

  const [userName, setUserName] = useState('');

  useEffect(() => {
    if (keycloak.authenticated) {
      keycloak
        .loadUserInfo()
        .then((userInfo) => {
          let userNameInfo = '';
          if (userInfo.given_name) {
            userNameInfo += userInfo.given_name;
          }
          userNameInfo += ' ';
          if (userInfo.family_name) {
            userNameInfo += userInfo.family_name;
          }
          setUserName(userNameInfo);
        })
        .catch((e) => keycloak.logout());
    }
  }, []);

  const [isEnabled] = useFetchEnv();
  const wrapperRef = useRef(null);
  const isDocsPath = checkPath(location.pathname, 'docs');
  const isDocsApiPath = location.pathname.indexOf('docs/apis/') !== -1;
  const isAuthVerefication = checkPath(location.pathname, 'realms');

  const headerLinksAuth = () => {
    return (
      <>
        <Desktop>
          <nav ref={wrapperRef} className={header.header__nav}>
            {!isDocsPath && (
              <NavigationMenu />
            )}
            <ul>
              <li>
                <Link className={header.header__link_docs} to={Routes.routes.APPLIST.path}>
                  <HeaderApps />
                  <p>{strings.header.text.appsLink}</p>
                </Link>
              </li>
              <li onClick={() => toggleSupportMessage({ status: false })}>
                <Link className={header.header__link_docs} to={Routes.routes.SUPPORT.path}>
                  <HeaderSupport />
                  <p>{strings.header.text.supportLink}</p>
                </Link>
              </li>
              <li>
                <a className={header.header__link_docs} href="https://staq.io/" target="_blank">
                  <HeaderFintoIo />
                  <p>{strings.header.text.mainPageLink}</p>
                </a>
              </li>
            </ul>
          </nav>
        </Desktop>
        <Tablet>
          <nav ref={wrapperRef} className={header.header__nav}>
            <ul>
              {!isDocsPath && (
                <NavigationMenu />
              )}

              <li>
                <Link className={header.header__link_docs} to={Routes.routes.APPLIST.path}>
                  <HeaderApps />
                  <p>{strings.header.text.appsLink}</p>
                </Link>
              </li>
            </ul>
            <div className={header.header__more}>
              <DropDown
                trigger={(isOpened) => (
                  <button
                    className={cn(header.header__btn_more, {
                      [header['header__btn_more--open']]: isOpened,
                    })}
                  >
                    <span>{strings.header.text.more}</span>
                    <ArrowPink />
                  </button>
                )}
                handleClose={() => {}}
              >
                {({ closeDropdown }) => (
                  <ul className={header.header__list_more}>
                    <li onClick={closeDropdown}>
                      <Link className={header.header__link_docs} to={Routes.routes.SUPPORT.path}>
                        <HeaderSupport />
                        <p>{strings.header.text.supportLink}</p>
                      </Link>
                    </li>
                    <li onClick={closeDropdown}>
                      <a
                        className={header.header__link_docs}
                        href="https://staq.io/"
                        target="_blank"
                      >
                        <HeaderFintoIo />
                        <p>{strings.header.text.mainPageLink}</p>
                      </a>
                    </li>
                  </ul>
                )}
              </DropDown>
            </div>
          </nav>
        </Tablet>
        <Burger onClick={setMenuOpen} />
      </>
    );
  };

  const logoutAction = async () => {
    history.push('/');
    await logout();
  };

  const renderProfile = () => {
    return (
      <>
        {userName && (
          <div className={header.header__user}>
            <DropDown
              className={dropdown.user}
              classNameTrigger={dropdown.trigger_user}
              classNameBody={dropdown.body_user}
              trigger={function (isOpened) {
                const { userName } = this;

                return (
                  <button
                    className={cn(header.header__btn_user, {
                      [header['header__btn_user--open']]: isOpened,
                    })}
                  >
                    <span>{userName}</span>
                    <ArrowIcon />
                  </button>
                );
              }.bind({ userName })}
              handleClose={() => {}}
            >
              {({ closeDropdown }) => (
                <div className={header.header__dropdown}>
                  <ul>
                    {isEnabled && isEnabled.toLowerCase() === 'true' && (
                      <li>
                        <div className={header.header__mode}>
                          {!isProdSwitcherOpen ? (
                            <span>{strings.header.text.sandBoxMode}</span>
                          ) : (
                            <span>{strings.header.text.prodMode}</span>
                          )}
                          <ProdSwitcher handleDiameter={17} height={11} width={27} />
                        </div>
                        <Divider variant="middle" />
                      </li>
                    )}
                    <li onClick={closeDropdown}>
                      <Link to={Routes.routes.PROFILE.path}>
                        <Icons.profile />
                        <p>{strings.header.text.profileLink}</p>
                      </Link>
                    </li>
                    <li onClick={closeDropdown}>
                      <Link to={Routes.routes.CERTIFICATES.path}>
                        <Icons.certificate />
                        <p>{strings.header.text.certificateLink}</p>
                      </Link>
                    </li>
                    <li onClick={closeDropdown}>
                      <button onClick={logoutAction} className={header.header__btn_logout}>
                        <Icons.logout />
                        <p>{strings.header.text.logoutLink}</p>
                      </button>
                    </li>
                    <li>
                      <div className={header.header__mode}>
                        {!isSwitcherOpen ? (
                          <span>{strings.header.text.lightMode}</span>
                        ) : (
                          <span>{strings.header.text.darkMode}</span>
                        )}
                        <Switcher handleDiameter={17} height={11} width={27} />
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </DropDown>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <header
        id="header"
        className={cn(header.header, enteredClassName, {
          [header.home]: isHeaderHome,
          [header.about]: isHeaderAbout,
          [header.contact]: isHeaderContact,
          [header.termslegals]: isHeaderTermsLegals,
          [header.authVerefication]: isAuthVerefication,
        })}
      >
        <div className={header.header__container}>
          <div className={header.header__versions}>
            <HeaderLink isDocs={isDocsPath} />
            {isDocsApiPath && (
              <ApiVersions location="header" />
            )}
          </div>
          {keycloak.authenticated ? (
            <>{headerLinksAuth()}</>
          ) : (
            <Mobile>
              <Burger onClick={setMenuOpen} />
            </Mobile>
          )}
          {keycloak.authenticated ? (
            renderProfile()
          ) : (
            <UnauthorizedLinks
              wrapperRef={wrapperRef}
              location={location}
            />
          )}
        </div>
      </header>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
